import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { LuInbox, LuArrowUpRight, LuTerminal } from 'react-icons/lu'
import { useModalClose } from '../hooks/useModalClose'
import { SERVICE_DOMAIN } from '../constants'
import useSharedServices from '../models/useSharedServices'
import DialogContent from '@mui/material/DialogContent'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Modal from './Modal'
import NodeData from './NodeData'

type Props = {
  inline?: boolean
}

export default function Shared({ inline }: Readonly<Props>) {
  const navigate = useNavigate()
  const { open } = useModalClose('/', inline)
  const { services, loaded, fetch } = useSharedServices()

  useEffect(() => {
    fetch()
  }, [fetch])

  const onClose = () => {
    if (inline) return
    navigate(-1)
  }

  return (
    <Modal
      open={open}
      inline={inline}
      maxWidth="xs"
      onClose={inline ? undefined : onClose}
      color="secondary.main"
      icon={
        <Box
          sx={{
            width: 54,
            height: 54,
            borderRadius: '50%',
            bgcolor: 'secondary.main',
            color: 'background.default',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: 2,
            borderColor: 'background.default',
          }}
        >
          <LuInbox size={28} />
        </Box>
      }
    >
      <DialogContent>
        <Stack spacing={3}>
          <Stack direction="row" sx={{
            alignItems: 'center'
          }}>
            <Typography variant="subtitle1" color="secondary" sx={{
              flexGrow: 1
            }}>
              Services shared with me
            </Typography>
          </Stack>

          {!loaded ? (
            <Typography variant="body2" sx={{
              color: 'text.secondary'
            }}>
              Loading…
            </Typography>
          ) : services.length === 0 ? (
            <Typography variant="body2" sx={{
              color: 'text.secondary'
            }}>
              No services have been shared with you.
            </Typography>
          ) : (
            <Box>
              {services.map(service => {
                const terminal = !service.url
                const href = terminal
                  ? `${window.location.origin}/terminal/${service.name}`
                  : `https://${service.name.toLowerCase()}.${SERVICE_DOMAIN}`
                const label = service.title || service.name
                return (
                  <NodeData
                    key={service.id}
                    icon={terminal ? <LuTerminal /> : <LuArrowUpRight />}
                    justifyIcon="center"
                    data={[
                      [
                        <Button
                          fullWidth
                          size="small"
                          color="secondary"
                          variant="contained"
                          href={href}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {label}
                        </Button>,
                      ],
                    ]}
                  />
                )
              })}
            </Box>
          )}
        </Stack>
      </DialogContent>
    </Modal>
  )
}
